<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="PackListForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <!-- *ngIf="submitButton" -->
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/img/feature.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                Paper Packing List
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            Paper Packing List
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr class="mt-2">

                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> List</mat-label>
                                                        <!-- <input matInput formControlName="" placeholder="Exam" > -->
                                                        <mat-select formControlName="EcId" #select2390
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select2390.focused"
                                                                [placeholder]="'Filter'"
                                                                [displayMember]="'item.ListDesc'" [array]="DataList"
                                                                (filteredReturn)=" filteredDataList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredDataList"
                                                                [value]="item.EcId" (click)="getList(item)">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                                    *ngIf="PackListForm.controls['EcId'].touched && PackListForm.controls['EcId'].errors?.required">
                                                                    Mandatory
                                                                </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput readonly formControlName="PcklistNo2"
                                                            placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput readonly formControlName="PcklistNo3"
                                                            placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Subject</mat-label>
                                                        <input matInput formControlName="SubCode" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Head</mat-label>
                                                        <input matInput formControlName="HdCode" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Medium</mat-label>
                                                        <input matInput formControlName="Medium" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Branch</mat-label>
                                                        <input matInput formControlName="Bran" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <!-- <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-3 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Valid</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="Valid"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Valid</mat-label>
                                                        <mat-select formControlName="Valid" #select1044 placeholder="Valid"
                                                        class="colorblack">
                                                        <mat-select-filter *ngIf="select1044.focused"
                                                        [placeholder]="'Filter'"></mat-select-filter>
                                                        <mat-option value="Y">Yes</mat-option>
                                                        <mat-option value="N">No</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>
                                            </div>
                                            <!-- <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>Changed</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="Chng"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Changed</mat-label>
                                                        <mat-select formControlName="Chng" #select1045 placeholder="Changed"
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select1045.focused"
                                                        [placeholder]="'Filter'"></mat-select-filter>
                                                            <mat-option value="Y">Yes</mat-option>
                                                            <mat-option value="N">No</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12">
                                        <button type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1 mb-2"
                                            (click)="Back()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/exit.gif"
                                                    style="margin-right: 5px;">
                                                Exit
                                            </span>
                                        </button>
                                        <button id="Print" type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1 mb-2">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/printer.gif">
                                                Print
                                            </span>
                                        </button>

                                        <button type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1 mb-2" (click)="fetchPackingList()">
                                            <!-- (click)="getData()" -->
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/list.gif"
                                                    style="margin-right: 7px;">
                                                List
                                            </span>
                                        </button>


                                    </div>
                                    <div class="col-sm-12 pl-0">
                                        <div  *ngIf="Table">
                                           
                                            <div class="table-responsive" id="table">
                                                <table id="datatable" class="table table-bordered text-nowrap">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600 text-center">
                                                                Subject
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Head
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Medium
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Center
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Count
                                                            </th>
                                                            <th class="f600 text-center">
                                                                100
                                                            </th>
                                                            <th class="f600 text-center">
                                                                50
                                                            </th>
                                                            <th class="f600 text-center">
                                                                25
                                                            </th>
                                                            <th class="f600 text-center">
                                                                10
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Total
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Valid
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Changed
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Branch
                                                            </th>
                                                            <th class="f600 text-center">
                                                                Action
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="PackingArray">
                                                        <!-- *ngFor="let data of packingList;" class="a" -->
                                                        <tr *ngFor="let data of getArrayControls(); let i = index" 
                                                        [formGroupName]="i" class="a">
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="PcSub">
                                                                <!-- {{data.SubCode}} -->
                                                                
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="HdCode">
                                                                
                                                                 <!-- {{data.HdCode}} -->
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="Medium">
                                                                <!-- {{data.PcMedium}} -->
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="Cent">
                                                                <!-- {{data.PcCent}} -->
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="Count">
                                                                
                                                                 <!-- {{data.PcCount}} -->
                                                            </td>
                                                            <td class="table1">
                                                                <input class="tab3 form-control input-sm"
                                                                    (keyup)="handleTab($event)" formControlName="P1">
                                                                    <!-- {{data.Pc1}} -->
                                                            </td>
                                                            <td class="table1">
                                                                <input class="tab3 form-control input-sm"
                                                                    (keyup)="handleTab($event)" formControlName="P2">
                                                                    <!-- {{data.Pc2}} -->
                                                            </td>
                                                            <td class="table1">
                                                                <input class="tab3 form-control input-sm"
                                                                    (keyup)="handleTab($event)" formControlName="P3">
                                                                   <!-- {{data.Pc3}} -->
                                                            </td>
                                                            <td class="table1">
                                                                <input class="tab3 form-control input-sm"
                                                                    (keyup)="handleTab($event)" formControlName="P4">
                                                                    <!-- {{data.Pc4}} -->
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="Total">
                                                                
                                                                 <!-- {{data.PcTotal}} -->
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="Valid">
                                                                
                                                                 <!-- {{data.PcValid}} -->
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="Chng">
                                                                
                                                                 <!-- {{data.PcChng}} -->
                                                            </td>
                                                            <td>
                                                                <input readonly class="tab2 form-control input-sm" formControlName="Bran">
                                                                
                                                                 <!-- {{data.StrCode}} -->
                                                            </td>
                                                            <td class="text-center"> 
                                                                <a class="floating mr-2 pr-3" title="Edit"
                                                                (click)="updateRow(data)"> 
                                                                <i class="fa fa-edit "></i> 
                                                            </a>
                                                        </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <!-- <hr> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12" *ngIf="Table">
                                        
                                            <button type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-2 mb-2" (click)="back()">
                                            
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/exit.gif"
                                                    style="margin-right: 5px;">
                                                Exit
                                            </span>
                                        </button>
                                        <button id="Update" type="button"
                                            class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-2 mb-2" (click)="updateAll()">
                                            <span style="display: contents; align-items: center;">
                                                <img width="20vh" src="../../assets/img/edit1.gif">
                                                Update
                                            </span>
                                        </button>
                                    </div>

                                </div>


                            </div>

                        </form>
                    </div>
                    <!-- list of Exam end  -->
                </div>
            </div>
        </div>
    </form>
</body>